import process from 'process'
import { Store } from 'redux'
import { ReactElement, useEffect } from 'react'
import { Provider } from 'react-redux'
import { BrowserRouter as Router } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import { Loader } from './components/Loader'
import ErrorBoundary from 'features/ErrorBoundary/ErrorBoundary'
import { AbilityContext, ability } from 'features/Permission'
import { AuthCheck } from 'features/Auth'
import Logger from 'services/Logger'
import AppRoutes from 'router'
import BottomNotificationsContextProvider from './features/BottomNotificationProvider/BottomNotificationsContextProvider'
import 'antd/dist/antd.min.css'
import BranchIOProvider from './features/BranchIO/BranchIOProvider'
import { AuthProvider } from '@descope/react-sdk'
import DevAppVersionProvider from './features/DevAppVersion/DevAppVersionProvider'
import ChatSocketProvider from 'features/ChatSocket/ChatSocketProvider'

export type AppProps = {
  store: Store
  logger: Logger
}

const hasServiceWorker = !!navigator.serviceWorker

const App = ({ store, logger }: AppProps): ReactElement => {
  useEffect(() => {
    window.addEventListener('resize', () => {
      document.documentElement.style.setProperty(
        '--inner-height',
        `${window.innerHeight}px`
      )
    })
  }, [])

  return (
    <AbilityContext.Provider value={ability}>
      <Helmet>
        <meta
          httpEquiv="Content-Security-Policy"
          content={`
            script-src 'self' https://static.descope.com https://descopecdn.com https://*.googleapis.com https://app.link/_r https://js.moov.io/ ; 
            object-src 'none'; 
            font-src 'self' https://fonts.gstatic.com https://descopecdn.com https://descopecdn.com/* data:; 
            ${
              hasServiceWorker
                ? 'worker-src blob: http://localhost:* https://*.community.ominnovations.health https://community.ominnovations.health; '
                : ''
            }
            img-src 'self' data: blob: ${
              process.env.REACT_APP_S3_BUCKET
            } https://*.community.ominnovations.health https://community.ominnovations.health https://*.descope.com https://descopecdn.com https://*.moov.io/ ;
            form-action 'self' https://zap ; 
            style-src 'self' 'unsafe-inline' https://fonts.googleapis.com ; 
            frame-src 'self' https://zap https://cards.moov.io/ ;
            default-src 'self' ${
              process.env.REACT_APP_S3_BUCKET
            } https://*.community.ominnovations.health https://community.ominnovations.health wss://*.community.ominnovations.health https://*.googleapis.com https://app.link/_r https://api2.branch.io https://*.descope.com https://descopecdn.com https://*.moov.io/ ;
          `}
        />
      </Helmet>
      <AuthProvider
        projectId={process.env.REACT_APP_DESCOPE_PROJECT_ID ?? ''}
        autoRefresh
      >
        <Router>
          <ErrorBoundary logger={logger}>
            <BranchIOProvider>
              <Provider store={store}>
                <ChatSocketProvider>
                  <BottomNotificationsContextProvider>
                    <AuthCheck>
                      <DevAppVersionProvider>
                        <AppRoutes />
                      </DevAppVersionProvider>
                    </AuthCheck>
                  </BottomNotificationsContextProvider>
                </ChatSocketProvider>
                <Loader />
              </Provider>
            </BranchIOProvider>
          </ErrorBoundary>
        </Router>
      </AuthProvider>
    </AbilityContext.Provider>
  )
}

export default App
